type Props = {
  level: number;
  isActive: boolean;
  matchingClinicCount: number;
};

export function ClinicMarker({ level, isActive, matchingClinicCount }: Props) {
  return (
    <div
      className={`cursor-pointer transition-all duration-200 md:hover:brightness-150 ${
        isActive ? 'z-50 scale-[180%] text-[0.5em]' : 'z-0 scale-[80%] '
      } transform transition duration-500 md:hover:scale-[180%] relative hover:text-[0.5em]`}
    >
      {matchingClinicCount > 0 && (
        <span className="text-white absolute top-[14px] left-1/2 transform -translate-x-1/2 -translate-y-1/2 font-extralight ">
          {matchingClinicCount}
        </span>
      )}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="35"
        viewBox="0 0 30 35"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M-0.000128579 -2.53775e-06L14.5141 34.6365L29.0283 0L29.0281 0C25.3679 2.54326 20.2183 4.12648 14.5141 4.12648C8.8098 4.12647 3.6602 2.54326 2.78235e-05 -2.53773e-06L-0.000128579 -2.53775e-06Z"
          fill={getColorByLevel(level)}
        />
        {isActive && (
          <>
            <mask id="path-2-inside-1_275_18439" fill="white">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.5142 3.96982L14.5142 30.22L25.5142 3.96983C22.3935 5.41557 18.6023 6.263 14.5142 6.263C10.4261 6.263 6.63485 5.41556 3.5142 3.96982Z"
              />
            </mask>

            <path
              d="M14.5142 30.22L12.8419 30.9207L14.5142 34.9114L16.1864 30.9207L14.5142 30.22ZM3.5142 3.96982L4.27638 2.32466L0.0356185 0.359983L1.84195 4.67057L3.5142 3.96982ZM25.5142 3.96983L27.1864 4.67058L28.9927 0.359988L24.752 2.32466L25.5142 3.96983ZM16.1864 29.5192L5.18646 3.26907L1.84195 4.67057L12.8419 30.9207L16.1864 29.5192ZM23.8419 3.26908L12.8419 29.5192L16.1864 30.9207L27.1864 4.67058L23.8419 3.26908ZM24.752 2.32466C21.8872 3.65187 18.3585 4.44985 14.5142 4.44985L14.5142 8.07614C18.8461 8.07614 22.8998 7.17927 26.2763 5.615L24.752 2.32466ZM14.5142 4.44985C10.6699 4.44985 7.14118 3.65187 4.27638 2.32466L2.75203 5.61499C6.12852 7.17926 10.1822 8.07614 14.5142 8.07614L14.5142 4.44985Z"
              fill="white"
              mask="url(#path-2-inside-1_275_18439)"
            />
          </>
        )}
      </svg>
    </div>
  );
}

function getColorByLevel(level: number) {
  switch (level) {
    // case 1:
    //   return '#111111';

    // case 2:
    //   return '#BA984F';

    // case 3:
    //   return '#C3C1C1';

    // case 4:
    //   return '#8F5948';

    // case 5:
    //   return '#66868C';

    default:
      return '#00363F';
  }
}
